var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ValidationObserver',{ref:"addressForm"},[_c('form',[_c('div',[_c('BaseLabel',{style:({
          'max-width': _vm.$vuetify.breakpoint.lgAndUp ? '480px' : '100%',
        }),attrs:{"text":"Postcode","actionBtnLabel":"Use address finder"},on:{"click:actionBtn":function($event){return _vm.openInputFindProperty()}}}),_c('BaseInput',{ref:"postCode",style:({
          'max-width': _vm.$vuetify.breakpoint.lgAndUp ? '480px' : '100%',
        }),attrs:{"vid":_vm.vid?.postCode,"fieldName":"postCode","value":_vm.addressForm.postCode.Value,"dataUiid":_vm.DATA_UIID.insuredAddressPostCode,"rules":{
          required: {
            fieldLabel: _vm.LABEL_CONSTANTS.POST_CODE_LABEL_MSG,
          },
          regex: {
            pattern: _vm.POST_CODE_PATTERN,
            customMessage: _vm.ERROR_MSG_CONSTANTS.ERROR_MSG_POSTCODE,
          },
        },"height":_vm.$vuetify.breakpoint.lgAndUp ? '48' : '60',"min-width":_vm.$vuetify.breakpoint.lgAndUp ? '110' : '',"aria-label":"Postcode"},on:{"blur":_vm.handleBlur}}),_c('BaseLabel',{attrs:{"text":_vm.LABEL_CONSTANTS.STREET}}),_c('BaseInput',{style:({
          'max-width': _vm.$vuetify.breakpoint.lgAndUp ? '480px' : '100%',
        }),attrs:{"vid":_vm.vid?.street,"fieldName":"street","dataUiid":_vm.DATA_UIID.insuredAddressStreet,"value":_vm.addressForm.street.Value,"rules":{
          required: {
            fieldLabel: _vm.LABEL_CONSTANTS.STREET_LABEL_MSG,
          },
          regex: {
            pattern: _vm.ALPHANUMERIC_AND_SPECIAL_CHARS_PATTERN,
            customMessage:
              _vm.ERROR_MSG_CONSTANTS.ERROR_MSG_ALPHANUMERIC_CHARACTERS_AND_SOME_SPECIAL_CHARACTER,
          },
          maxLength: {
            fieldLabel: _vm.LABEL_CONSTANTS.STREET_LABEL_MSG,
            length: 30,
          },
        },"height":_vm.$vuetify.breakpoint.lgAndUp ? '48' : '60',"min-width":_vm.$vuetify.breakpoint.lgAndUp ? '110' : '',"aria-label":"Street"},on:{"blur":_vm.handleBlur}}),_c('BaseLabel',{attrs:{"text":_vm.LABEL_CONSTANTS.DISTRICT}}),_c('BaseInput',{style:({
          'max-width': _vm.$vuetify.breakpoint.lgAndUp ? '480px' : '100%',
        }),attrs:{"vid":_vm.vid?.district,"fieldName":"district","dataUiid":_vm.DATA_UIID.insuredAddressDistrict,"value":_vm.addressForm.district.Value,"rules":{
          regex: {
            pattern: _vm.ALPHANUMERIC_AND_SPECIAL_CHARS_PATTERN,
            customMessage:
              _vm.ERROR_MSG_CONSTANTS.ERROR_MSG_ALPHANUMERIC_CHARACTERS_AND_SOME_SPECIAL_CHARACTER,
          },
          maxLength: {
            fieldLabel: _vm.LABEL_CONSTANTS.DISTRICT_LABEL_MSG,
            length: 30,
          },
        },"height":_vm.$vuetify.breakpoint.lgAndUp ? '48' : '60',"min-width":_vm.$vuetify.breakpoint.lgAndUp ? '110' : '',"aria-label":"District"},on:{"blur":_vm.handleBlur}}),_c('BaseLabel',{attrs:{"text":_vm.LABEL_CONSTANTS.TOWN}}),_c('BaseInput',{style:({
          'max-width': _vm.$vuetify.breakpoint.lgAndUp ? '480px' : '100%',
        }),attrs:{"vid":_vm.vid?.town,"fieldName":"town","dataUiid":_vm.DATA_UIID.insuredAddressTown,"value":_vm.addressForm.town.Value,"rules":{
          required: {
            fieldLabel: _vm.LABEL_CONSTANTS.TOWN_LABEL_MSG,
          },
          regex: {
            pattern: _vm.ALPHANUMERIC_AND_SPECIAL_CHARS_PATTERN,
            customMessage:
              _vm.ERROR_MSG_CONSTANTS.ERROR_MSG_ALPHANUMERIC_CHARACTERS_AND_SOME_SPECIAL_CHARACTER,
          },
          maxLength: {
            fieldLabel: _vm.LABEL_CONSTANTS.TOWN_LABEL_MSG,
            length: 30,
          },
        },"height":_vm.$vuetify.breakpoint.lgAndUp ? '48' : '60',"min-width":_vm.$vuetify.breakpoint.lgAndUp ? '110' : '',"aria-label":"Town"},on:{"blur":_vm.handleBlur}}),_c('BaseLabel',{attrs:{"text":_vm.LABEL_CONSTANTS.COUNTY}}),_c('BaseInput',{style:({
          'max-width': _vm.$vuetify.breakpoint.lgAndUp ? '480px' : '100%',
        }),attrs:{"vid":_vm.vid?.county,"fieldName":"county","dataUiid":_vm.DATA_UIID.insuredAddressCounty,"value":_vm.addressForm.county.Value,"rules":{
          regex: {
            pattern: _vm.ALPHANUMERIC_AND_SPECIAL_CHARS_PATTERN,
            customMessage:
              _vm.ERROR_MSG_CONSTANTS.ERROR_MSG_ALPHANUMERIC_CHARACTERS_AND_SOME_SPECIAL_CHARACTER,
          },
          maxLength: {
            fieldLabel: _vm.LABEL_CONSTANTS.COUNTY_LABEL_MSG,
            length: 30,
          },
        },"height":_vm.$vuetify.breakpoint.lgAndUp ? '48' : '60',"min-width":_vm.$vuetify.breakpoint.lgAndUp ? '110' : '',"aria-label":"County"},on:{"blur":_vm.handleBlur}})],1),_vm._t("saveButton")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }